/* eslint-disable max-len */
import React, { useContext, useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { useLocation } from 'react-router-dom';
import GlobalContext from '../Context/GloablContext';
import { handleIsAPICall } from '../../redux/commonSlice';
import { useDispatch,useSelector } from 'react-redux';
const Toast = ({ message, type,setToastmessage,modal }) => {
    const dispatch=useDispatch()
    const location=useLocation()
    const [showToast, setShowToast] = useState(true);
    const {isSideBar, setIsSideBar,show, setshow} = useContext(GlobalContext);
    const auth=useSelector(state=>state?.auth)
    const {loggedIn}=auth
    /* This `useEffect` hook is setting a timer using `setTimeout` function to hide the toast message
    after 5 seconds (5000 milliseconds) and also resetting the `toastMessage` state to an empty
    string. The `clearTimeout` function is used to clear the timer when the component unmounts. The
    empty dependency array `[]` ensures that this effect runs only once when the component mounts. */
    useEffect(() => {
        const timer = setTimeout(() => {
            setShowToast(false);
            setToastmessage('')
            //dispatch(handleIsAPICall(true))
        }, 8000);

        return () => {
            clearTimeout(timer);
        };
    }, []);


    
    

    return (
        <>
            {showToast && message!==""&& message && (
                // <div className={`items-center alert alert-dismissible fade ${type === 'error' ? `${location.pathname === "/" ?  'left-[50%]': "left-[45%]"} -translate-x-[50%] absolute` : "right-5"}  w-max top-[6px] z-[9999] absolute shadow-s2 rounded-[16px] ${type}`}>
                <div className={`items-center alert alert-dismissible fade rounded-[16px] ${type} `}>
                    <motion.div
                        initial={type === 'error' ? { y: -1000 } : { x: 20 }}
                        animate={type === 'error' ? { y: 0 } : { x: 0}}
                        transition={{ duration: 1 }}
                        exit={{ opacity: 0.5 }}
                        onClick={()=>{setShowToast(!showToast); setToastmessage('')}}
                        className={`items-center alert alert-dismissible fade w-max z-[9999] ${type} ${type==='error'?(!isSideBar&&loggedIn)?'error-msg-open':'error-msg-placement':'absolute z-[9999] right-6'} top-[8px]`}
                        // className={`items-center alert alert-dismissible fade w-max z-[999] absolute ${!isSideBar && type==="error" ? modal!==undefined &&modal===true?'left-[-168px]':'left-[-68px]' : type!=="error"?'right-10':'left-[-185px]'}  rounded-[16px] ${type}`}
                    >
                        <motion.div
                            initial={{ opacity: 0, x: 0 }}
                            animate={{ opacity: 1, x: 0 }}
                            transition={{ delay: 0.2, duration: 0.3 }}
                            exit={{ opacity: 0.5 }}
                            className={`flex items-center justify-center border-[1.5px]  ${type === 'error' ? "bg-[#F9E8E9] border-[#C81720]" : type === 'warn' ? "bg-[#FCEFE9] border-[#DF6420]" :"bg-[#C5FFD5] border-[#00CF3A]"} rounded-[16px] cursor-pointer p-3 xl:w-max max-w-[820px] text-center`}
                        >
                            <span>
                                {type === 'error' && <div className='w-full h-10 flex justify-center items-center bg-[#C81720] rounded-full'><img src="/images/error_toast.svg" alt="icon" className='p-2.5' /></div>}
                                {type === 'success' && <div className='w-full h-10 flex justify-center items-center bg-[#1A883C] rounded-full'><img src="/images/success_toast.svg" alt="icon" className='p-2.5' /></div>}
                                {type === 'warn' && <div className='w-full h-10 flex justify-center items-center bg-[#FCEFE9] rounded-full'><img src="/images/warn.svg" alt="icon" className='p-2.5' /></div>}
                                {/* Add other icon options as needed */}
                            </span>
                            <p className="text-sm text-[#000000] font-semibold px-5" id="toast-message">{message}</p>
                            <span><img src="/images/close_icon.svg" alt="icon" /></span>
                        </motion.div>
                    </motion.div>
                </div>
            )}
        </>
    );
};

export default Toast;
